import { language as lan_simpleCustomizePreview } from "./simple-customize-preview";

let language = {
    ...lan_simpleCustomizePreview,

    STORE_ORDER_PLATFORM_STATUS: "状态:",
    
    STORE_ORDER_TOTAL: "总计:",

    // shipping-info
    STORE_ORDER_SHIPPING_INFO_STORE_NAME: "商店名称:",
    STORE_ORDER_SHIPPING_INFO_BILLING_ADDRESS: "账单地址:",
    STORE_ORDER_SHIPPING_INFO_SHIPPING_ADDRESS: "送货地址:",
    STORE_ORDER_SHIPPING_INFO_DELIVERY_TYPE: "配送类型:",
    STORE_ORDER_SHIPPING_INFO_PAYMENT_TYPE: "付款方式:",
    STORE_ORDER_SHIPPING_INFO_TRACKING_NUMBER: "快递单号:",
    STORE_ORDER_SHIPPING_INFO_TRACKING_METHOD: "配送方法:",

    // item
    STORE_ORDER_ITEM_PAYMENT_SUBTOTAL: "支付小计:",
    STORE_ORDER_ITEM_SUBWEIGHT: "总重量:",
    STORE_ORDER_ITEM_PAYMENT_STATUS_LABEL: "支付状态:",
    STORE_ORDER_ITEM_PAYMENT_STATUS_UNSUBMITTED: "未提交",
    STORE_ORDER_ITEM_PAYMENT_STATUS_SUBMITTED: "已提交",
    STORE_ORDER_ITEM_PRICE: "价格:",
    STORE_ORDER_ITEM_WEIGHT: "重量:",
    STORE_ORDER_ITEM_PREVIEW_ACTION: "预览",
    STORE_ORDER_ITEM_SITE_ORDER_NUMBER: "订单号:",

    // checkout-info
    STORE_ORDER_TOTAL_WEIGHT: "总重量:",
    STORE_ORDER_RECEIVE_SUBTOTAL: "接收小计:",
    STORE_ORDER_RECEIVE_TAX: "接收税额:",
    STORE_ORDER_RECEIVE_SHIPPING_FEE: "接收运费:",
    STORE_ORDER_RECEIVE_TOTAL: "接收总计:",

    // btn
    STORE_ORDER_BTN_BACK: "返回",
    STORE_ORDER_BTN_SUBMIT: "提交",
    STORE_ORDER_BTN_COMBINE_ORDER: "拼单",
    STORE_ORDER_BTN_DELETE: "删除",
};

export { language }
